import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

import LoginForm from './components/LoginForm';
import RegistrationForm from './components/RegistrationForm';
import SecurityBadges from './components/SecurityBadges';

const TeacherLogin = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="fixed top-0 left-0 right-0 z-50 bg-card shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate('/splash-page')}
              className="flex items-center space-x-3 hover-lift transition-organic"
            >
              <div className="header-logo">
                <Icon name="BookOpen" size={24} className="header-logo-icon" />
              </div>
              <span className="header-logo-text">LearningTrails</span>
            </button>
          </div>
        </div>
      </div>
      <div className="pt-16 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            <div className="bg-card rounded-xl shadow-lg p-6 md:p-8 lg:p-10 stagger-fade-in">
              <LoginForm />
            </div>

            <div className="bg-card rounded-xl shadow-lg p-6 md:p-8 lg:p-10 stagger-fade-in stagger-delay-1">
              <RegistrationForm />
            </div>
          </div>

          <div className="mt-8 lg:mt-12 stagger-fade-in stagger-delay-2">
            <SecurityBadges />
          </div>

          <div className="mt-8 lg:mt-12 text-center stagger-fade-in stagger-delay-3">
            <div className="inline-flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="HelpCircle" size={16} />
              <span>Need help?</span>
              <button className="text-primary hover:text-primary/80 transition-organic">
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-card border-t border-border mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} LearningTrails. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <button className="text-sm text-muted-foreground hover:text-foreground transition-organic">
                Privacy Policy
              </button>
              <button className="text-sm text-muted-foreground hover:text-foreground transition-organic">
                Terms of Service
              </button>
              <button className="text-sm text-muted-foreground hover:text-foreground transition-organic">
                Help Center
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TeacherLogin;